<template>
	<div class="gift-body">
		<div style="width:100%;flex:1;display:flex;flex-direction: column;overflow-y:auto">
			<div class="order-menu">
				<span>
					<i class="el-icon-back" @click="goBack"></i>
				</span>{{isAdd ? '新增优惠券' : '编辑优惠券'}}
			</div>
			<div class="fx-title">
				<span>基础信息</span>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					优惠券类型：
				</div>
				<div class="gift-row-content">
					<el-select v-model="type" :disabled="isDisable || discountState || isHistory" @change="typeChange" class="filter-input" size='mini'>
						<el-option :value='1' label="满减券"></el-option>
						<el-option :value='6' label="商品券"></el-option>
					</el-select>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					优惠券名称：
				</div>
				<div class="gift-row-content" style="flex:1;display:flex;align-items: center;justify-content: space-between;">
					<el-input style="width:200px" v-model="name" maxlength="10" :disabled="isDisable || isHistory" size="mini" placeholder="不超过10字"></el-input>
					<el-button size="mini" plain type="primary" @click="previewClick" style="margin-right:20px">预览效果</el-button>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					使用门槛：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="useconditionflag" :label="0">无门槛使用</el-radio>
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="useconditionflag" :label="1">订单满金额</el-radio>
					<el-input v-if="useconditionflag === 1" size="mini" :disabled="isDisable || discountState || isHistory" placeholder="请输入内容" @blur="useconditionmoneyBlur" @input="useconditionmoneyCheck" v-model="useconditionmoney">
						<template slot="append">元</template>
					</el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					优惠内容：
				</div>
				<div class="gift-row-content">
					<div style="flex-shrink: 0;margin-right: 10px;">减免</div>
					<el-input size="mini" :disabled="isDisable || discountState || isHistory" placeholder="请输入内容" @input="reliefmoneyCheck" @blur="reliefmoneyBlur" v-model="reliefmoney">
						<template slot="append">元</template>
					</el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					使用时间：
				</div>
				<div class="gift-row-content">
					<div>
						<el-radio :disabled="isDisable || discountState || isHistory" v-model="discountDateType" @change="discountDateTypeChange" :label="1">有效期</el-radio>
						<el-date-picker
							:disabled="isDisable || discountState || isHistory"
							v-model="dateValue"
							:clearable="false"
							:unlink-panels='true'
							@change="dateValueChange"
							class="time-input"
							size="mini"
							type="datetimerange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							:default-time="['00:00:00', '23:59:59']"
							format='yyyy-MM-dd HH:mm:ss'
							value-format='yyyy-MM-dd HH:mm:ss'>
						</el-date-picker>
					</div>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
				</div>
				<div class="gift-row-content" style="width:400px">
					<el-radio :disabled="isDisable || discountState || isHistory" @change="discountDateTypeChange" v-model="discountDateType" :label="0">永久</el-radio>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					优惠叠加：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="addupflag" :label="0">不可与其它活动叠加使用</el-radio>
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="addupflag" :label="1">可与其它活动叠加使用</el-radio>
				</div>
			</div>
			<div class="gift-row" style="margin: 20px 0;">
				<div class="gift-row-title">
					使用说明：
				</div>
				<div class="gift-row-content">
					<el-input
						maxlength="300"
						:disabled="isDisable || isHistory"
						style="width: 400px;"
						type="textarea"
						size="mini"
						placeholder="请输入内容"
						v-model="memo">
					</el-input>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					上架/发放时间：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="coupondatetype" :label="0">规定时间</el-radio>
						<el-date-picker
							v-model="coupondate"
							:clearable="false"
							type="datetime"
							:picker-options="pickerOptions"
							:disabled="isDisable || discountState || isHistory"
							class="time-input"
							size="mini"
							format='yyyy-MM-dd HH:mm:ss'
							value-format='yyyy-MM-dd HH:mm:ss'>
						</el-date-picker>
						<span style="margin-left:10px">
							注：时间选择为有效期开始时间之前或等于有效期开始时间
						</span>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
				</div>
				<div class="gift-row-content" style="width:400px">
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="coupondatetype" :label="1">立即上架/发放</el-radio>
				</div>
			</div>

			<div class="fx-title">
				<span>券限制信息</span>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					获取方式：
				</div>
				<div class="gift-row-content">
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="forceflag" :label="0">强制发放</el-radio>
					<!-- <el-radio disabled v-model="forceflag" :label="1">主动领取</el-radio> -->
				</div>
			</div>
			<div>
				<div style="display: flex;align-items: center;height: 40px;">
					<div style="width:130px;text-align: right;font-size: 13px;">
						<span style="color:#EE4F31">*</span>适用店铺：
					</div>
					<el-radio style="min-height: 40px;;line-height: 40px;" :disabled="isDisable || discountState || isHistory" v-model="shopattendway" :label="0">全部店铺</el-radio>
					<el-radio style="min-height: 40px;;line-height: 40px;" :disabled="isDisable || discountState || isHistory" v-model="shopattendway" :label="1">部分店铺</el-radio>
					<div  v-if="shopattendway === 1 && !isDisable && !discountState && !isHistory" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择店铺
					</div>
				</div>
				<div v-if="shopattendway === 1" style="display: flex;">
					<div style="width:130px;text-align: right;line-height: 30px;font-size: 13px;">
						已选：
					</div>
					<div style="display:flex;align-items: center;line-height:30px;text-align: left;">{{shopText}}</div>
				</div>
			</div>
			<div class="gift-row">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					适用客户：
				</div>
				<div class="gift-row-content" style="width:400px">
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="attendway" :label="0">全部客户</el-radio>
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="attendway" :label="1">自定义客户</el-radio>
				</div>
			</div>
			<div class="gift-row" v-if="attendway === 0">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					每个客户发券数量：
				</div>
				<div class="gift-row-content" style="width:200px">
					<el-input v-model="couponamount" size="mini" :disabled="isDisable || discountState || isHistory" @blur="couponamountBlur" @input="couponamountCheck" placeholder="请输入内容" ></el-input>
				</div>
			</div>
			<div class="gift-row" v-if="!isDisable && discountState && !isHistory && attendway === 0">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					每个客户增发数量：
				</div>
				<div class="gift-row-content" style="width:200px">
					<el-input v-model="increaseCount" size="mini"  @blur="increaseCountBlur" @input="increaseCountCheck" placeholder="请输入内容" ></el-input>
				</div>
			</div>
			<div v-if="attendway === 1" style='margin-left:130px;min-height:30px;display:flex;margin-top: 5px;align-items: center;justify-content: space-between;'>
				<span v-if="attendway === 1 && !isDisable && !discountState && !isHistory" @click="addCusClick" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
					<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
					选择客户
				</span>
				<el-input
					style='width:260px'
					v-model="cusKeyword"
					:placeholder="customertype === 0 ? '输入客户类别名称':'输入客户名称或注册码'"
					size="mini"
						>
					<el-button style="height:28px" slot="append" icon="el-icon-search" @click="cusSearch"></el-button>
				</el-input>
			</div>
			<div style="width:100%;min-height:200px;margin-top:10px;padding-left:130px;box-sizing: border-box;" v-if="attendway === 1">
				<el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				:data="cusTable"
				height="100%"
				border>
					<el-table-column
						prop="customername"
						v-if="customertype === 1"
						key="customername"
						label="客户"
						align="center"
						min-width="160">
						<template slot-scope='scope'>
							<div>{{scope.row.customername}}</div>
							<div>注册码：{{scope.row.syscode}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="categoryname"
						label="客户类别"
						align="center"
						min-width="100">
					</el-table-column>
					<el-table-column
						prop="couponamount"
						key="couponamount"
						label="发券数量"
						align="center"
						min-width="160">
						<template slot="header">
							<div>
								发券数量
								<i v-if="!isDisable && !discountState && !isHistory" class="el-icon-edit" style="color: var(--fx-primary-color);cursor: pointer;" @click="editNum(false)"></i>
							</div>
						</template>
						<template slot-scope='scope'>
							<el-input :disabled="isDisable || discountState || isHistory" style="width:80%" @input="rowCouponamountCheck(scope.row)" @blur="rowCouponamountBlur(scope.row)" v-model="scope.row.couponamount" size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column
						v-if="!isDisable && discountState && !isHistory"
						prop="addcouponamount"
						key="addcouponamount"
						label="增发数量"
						align="center"
						min-width="160">
						<template slot="header">
							<div>
								增发数量
								<i class="el-icon-edit" style="color: var(--fx-primary-color);cursor: pointer;" @click="editNum(true)"></i>
							</div>
						</template>
						<template slot-scope='scope'>
							<el-input style="width:80%" @input="rowIncreaseCountCheck(scope.row)" @blur="rowIncreaseCountBlur(scope.row)" v-model="scope.row.increaseCount" size="mini"></el-input>
						</template>
					</el-table-column>
					<el-table-column v-if="!isDisable && !discountState && !isHistory" label="操作" min-width="100" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click='delCusClick(scope.row)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="attendway === 1 && customertype === 1" style='margin-left:130px;min-height:30px;display:flex;margin-top: 5px;align-items: center;'>
				<div>总计客户：{{cusAll.length}}</div>
				<div style="margin-left:20px">券张数合计:{{couponamountAll}}</div>
			</div>
			<div class="gift-row" v-if="type === 6">
				<div class="gift-row-title">
					<span style="color:#EE4F31">*</span>
					适用商品：
				</div>
				<div class="gift-row-content" style="width:400px">
					<!-- <el-radio :disabled="isDisable || discountState || isHistory" v-model="productattendway" :label="0">全部商品可用</el-radio> -->
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="productattendway" :label="1">指定商品可用</el-radio>
					<el-radio :disabled="isDisable || discountState || isHistory" v-model="productattendway" :label="2">指定分类可用</el-radio>
				</div>
			</div>


			<div v-if="productattendway === 1" style='margin-left:130px;min-height:30px;display:flex;margin-top: 5px;align-items: center;justify-content: space-between;'>
				<div v-if="productattendway === 1 && !isDisable && !discountState && !isHistory" @click="addProduct" style="margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
					<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
					选择商品
				</div>
				<el-input
					style='width:260px'
					v-model="proKeyword"
					placeholder="输入商品名称或编号"
					size="mini"
						>
					<el-button style="height:28px" slot="append" icon="el-icon-search" @click="proSearch"></el-button>
				</el-input>
			</div>
			<div v-if="productattendway === 1" style="width:100%;min-height:200px;margin-top:10px;padding-left:130px;box-sizing: border-box;">
				<el-table
				:stripe='true'
				size='mini'
				class="grid-content"
				:data="proTable"
				height="100%"
				border>
					<el-table-column
						prop="visibleflag"
						label="商品信息"
						align="center"
						min-width="160">
						<template slot-scope='scope'>
							{{scope.row.productname}}
							<div>{{scope.row.productcode}}</div>
						</template>
					</el-table-column>
					<el-table-column
						prop="typeCategory"
						label="所属类别"
						align="center"
						min-width="100">
					</el-table-column>
					<el-table-column v-if="!isDisable && !discountState && !isHistory" label="操作" min-width="100" align="center">
						<template slot-scope="scope">
							<el-button type='text' size="mini" @click='delClick(scope.row.productid)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div v-if="productattendway === 1" style='margin-left:130px;min-height:30px;display:flex;margin-top: 5px;align-items: center;'>
				<div>商品总计：{{proAll.length}}</div>
			</div>
			<div v-if="productattendway === 2" style="width:100%;padding-left:130px;box-sizing: border-box;">
				<el-checkbox-group v-model="checkList" style="display:flex;flex-wrap: wrap;">
					<el-checkbox style="margin:5px" v-for="(item,index) in categoryList" :disabled="isDisable || discountState || isHistory" :key='index' :label="item.id">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
		<div style="height:60px;line-height:60px;width:100%;text-align:center">
			<el-button size="mini" v-if="!isDisable && !isHistory" type="primary" @click='saveClick'>保存</el-button>
		</div>
		<el-dialog
			title="选择商品"
			:visible.sync="productModel"
			class="dialog-title"
			width="1260px"
			top="60px"
			@open="search"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div class="filters-container">
					<div class="input-box">
						<span>商品类别：</span>
						<el-select filterable v-model="typeCategory" class="filter-input" size='mini'>
							<el-option value="0" label="全部"></el-option>
							<el-option :value="item.id" :label="item.name" v-for="item in categoryList" :key="item.id"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<span>启用状态：</span>
						<el-select v-model="productDisabledflag" class="filter-input" size='mini'>
							<el-option :value='-1' label="全部"></el-option>
							<el-option :value='0' label="启用"></el-option>
							<el-option :value='1' label="停用"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<el-input
							v-model="productKeyword"
							placeholder="商品名称/编号"
							size="mini"
							@keyup.enter.native="searchClick">
						</el-input>
					</div>
					<el-button size="small" type="primary" class="btn fx-btn" @click="searchClick">查询</el-button>
					<el-button size="small" plain class="btn fx-btn" @click="clearSearch">清空</el-button>
				</div>
				<el-table
					class="grid-content"
					:data="productTableData"
					border
					size='mini'
					height="400"
					ref="table"
					@select="handleSelectionChange"
					@select-all="handleSelectionChange"
				>
					<el-table-column
						key='checkbox'
						type="selection"
						align="center"
						width="40">
					</el-table-column>
					<el-table-column
						key='typeCategory'
						prop="typeCategory"
						label="商品类别"
						align="center">
					</el-table-column>
					<el-table-column
						key="productname"
						prop="productname"
						label="商品名称"
						align="center">
					</el-table-column>
					<el-table-column
						key="productcode"
						prop="productcode"
						label="SPU编号"
						align="center">
					</el-table-column>
					<el-table-column
						key="disabledflag"
						prop="disabledflag"
						label="启用状态"
						align="center">
						<template slot-scope='scope'>
							<div class="point-box">
								<div v-if="!scope.row.disabledflag" class='point' style="background-color:#60C769"></div>
								<div v-if="scope.row.disabledflag" class='point' style="background-color:#ED4F31"></div>
								<span>{{scope.row.disabledflag ? '已停用' : '已启用'}}</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div style="display: flex;align-items: center;justify-content: space-between;height: 40px;">
					<div>
					</div>
					<el-pagination
						style="margin: 10px; text-align: center;"
						@size-change="productSizeChange"
						@current-change="productPageChange"
						:current-page="productPagination.page"
						:page-sizes="[20, 40, 60, 100, 300]"
						:page-size="productPagination.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="productTotalCount">
					</el-pagination>
				</div>
				<div class="valet-foot">
					<el-button plain type="primary" size='small' @click='cancelClick'>取消</el-button>
					<el-button plain type="primary" size='small' @click='addproductClick'>添加</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="选择客户"
			:visible.sync="customerDialog"
			class="dialog-title"
			width="780px"
			top="60px"
			:close-on-click-modal="false">
			<div class="dialog-body">
				<bind-customer v-if="customerDialog" :customerDialog.sync="customerDialog" @reloadCus='reloadCus' :customertype='customertype' :chooseCusByCate='chooseCusByCate' :chooseCusBylevel='chooseCusBylevel'></bind-customer>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			width="780px"
			append-to-body
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			:title="isAddEdit ? '统一设置增发数量': '统一设置发券数量'"
			class="dialog-title"
			:visible.sync="editNumModel"
			width="400px"
			append-to-body
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div style='display:flex;height:40px;align-items: center;'>
					<span v-if='!isAddEdit'>发券数量：</span>
					<span v-if='isAddEdit'>增发数量：</span>
					<el-input style="width:200px" v-model="mutiCouponamount" @input="mutiCouponamountCheck" @blur="mutiCouponamountBlur" size="mini" placeholder="请输入内容" ></el-input>
				</div>
				<div style="display :flex;align-items center;justify-content :center;margin-top:10px">
					<el-button plain type="primary" size='small' @click='cancelMutiClick'>取消</el-button>
					<el-button plain type="primary" size='small' @click='saveMutiClick'>保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="优惠券预览"
			class="dialog-title"
			:visible.sync="previewModel"
			width="400px"
			append-to-body
			:close-on-click-modal="false">
			<div class="dialog-body">
				<div>
					<div class="li-top">
					<img class="head-img" src="~/images/icon/coupon-bg.png">
					<div class="li-left">
						<div class="left-title" v-if="type === 1">
							<div class="left-cion">满减券</div>
							{{name === '' ? '满减券名称' : name}}
						</div>
						<div class="left-title" v-if="type === 6">
							<div class="left-cion">商品券</div>
							{{name === '' ? '商品券名称' : name}}
						</div>
						<div v-if="discountDateType === 1">
							<div v-if="dateValue.length>0">{{dateValue[0].split(' ')[0]}}——{{dateValue[1].split(' ')[0]}}</div>
							<div v-else>使用开始时间-截至时间</div>
						</div>
						<div v-if='discountDateType !== 1'>永久有效</div>
						<div class="left-shop">
							<span v-if="shopattendway === 0">全部店铺</span>
							<span v-if="shopattendway === 1">部分店铺</span>
							/
							<span v-if="productattendway ===0">全部商品</span>
							<span v-if="productattendway ===1">指定商品</span>
							<span v-if="productattendway ===2">指定分类</span>
							<img class="arrow-icon" src="~/images/icon/arrow-down.png"></div>
					</div>
					<div class="li-right">
						<div><span style="font-size:18px">￥</span><span style="font-size:20px;line-height: 28px;">{{reliefmoney}}</span></div>
						<div v-if="useconditionflag === 0">满任意金额可用</div>
						<div v-if="useconditionflag === 1">满{{useconditionmoney}}元可用</div>
						<div class="right-use">立即使用</div>
					</div>
					</div>
					<div class="li-des">
						{{memo}}
					</div>
				</div>
				<div style="display :flex;align-items center;justify-content :center;margin-top:10px">
					<el-button plain type="primary" size='small' @click='cancelPreviewClick'>关闭预览</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import BindCustomer from './bindCustomer.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'gift',
	components: {
		BindCustomer,
		bindShop
	},
	data () {
		return {
			orginName: '',
			type: 1,
			discountState: false,
			proKeyword: '',
			cusKeyword: '',
			isAdd: false,
			AuthorityList: {
				'08_0002_0001_00': false,
				'08_0002_0002_00': false,
				'08_0002_0003_00': false,
				'08_0002_0004_00': false
			},
			productPagination: {
				page: 1,
				size: 20
			},
			increaseCount: 0,
			productTotalCount: 0,
			categoryList: [],
			productKeyword: '',
			productDisabledflag: -1,
			typeCategory: '0',
			disabledflag: false,
			name: '',
			useconditionflag: 0,
			useconditionmoney: 0,
			reliefmoney: 0,
			addupflag: 0,
			discountDateType: 1,
			attendway: 0,
			dateValue: [],
			coupondatetype: 0,
			memo: '1、不可与其它活动/优惠券叠加使用 2、适用店铺：全部店铺 3、如订单发生退款、优惠券不退还',
			coupondate: '',
			forceflag: 0,
			productattendway: 0,
			proTable: [],
			proAll: [],
			checkList: [],
			couponamount: 1,
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			productModel: false,
			productTableData: [],
			chooseData: null,
			discountId: '',
			customerDialog: false,
			chooseCusByCate: [],
			chooseCusBylevel: [],
			chooseCus: [],
			customertype: 0,
			isDisable: true,
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'productid'
			}),
			productmoney: '',
			shopattendway: 0,
			shopDialog: false,
			shopText: '',
			chooseShop: [],
			cusAll: [],
			cusTable: [],
			cusOld: [],
			editNumModel: false,
			isAddEdit: false,
			previewModel: false,
			isHistory: false,
			mutiCouponamount: 1,
			couponamountAll: 0,
			pickerOptions: {
				disabledDate: (time) => {
					if (this.discountDateType === 1 && this.dateValue.length > 0) {
						return time.getTime() > this.getMintinme()
					}
				}
			}
		}
	},
	created () {
		this.getAuthority('08_0003_0000_00')
		this.getCategoryList()
		let id = window.sessionStorage.getItem('discountId')
		let isHistory = window.sessionStorage.getItem('discountHistory')
		if (isHistory) {
			this.isHistory = true
		} else {
			this.isHistory = false
		}
		if (id) {
			this.isAdd = false
			this.discountId = id
			this.getDetail()
		} else {
			this.discountState = false
			this.isAdd = true
		}
	},
	computed: {
		chooseProduct () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		typeChange () {
			if (this.type === 1) {
				this.productattendway = 0
			} else {
				this.productattendway = 1
			}
		},
		getMintinme () {
			if (this.dateValue && this.dateValue.length > 0) {
				var date = this.dateValue[1]
				date = date.substring(0, 19)
				date = date.replace(/-/g, '/')
				var timestamp = new Date(date).getTime()
				return timestamp
			}
		},
		discountDateTypeChange () {
			this.coupondate = ''
		},
		dateValueChange () {
			this.coupondate = ''
		},
		cancelPreviewClick () {
			this.previewModel = false
		},
		previewClick () {
			this.previewModel = true
		},
		proSearch () {
			if (this.proKeyword === '') {
				this.proTable = this.proAll
				return false
			}
			let arr = []
			this.proAll.forEach(item => {
				if (item.productname.indexOf(this.proKeyword) !== -1 || (item.productcode + '').indexOf(this.proKeyword) !== -1) {
					arr.push(item)
				}
			})
			this.proTable = arr
		},
		cusSearch () {
			if (this.cusKeyword === '') {
				this.cusTable = this.cusAll
				return false
			}
			let arr = []
			this.cusAll.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryname.indexOf(this.cusKeyword) !== -1) {
						arr.push(item)
					}
				} else {
					console.log(item.syscode)

					if (item.customername.indexOf(this.cusKeyword) !== -1 || (item.syscode + '').indexOf(this.cusKeyword) !== -1) {
						arr.push(item)
					}
				}
			})
			this.cusTable = arr
		},
		rowIncreaseCountCheck (row) {
			row.increaseCount = row.increaseCount.replace(/[^\d]/g, '')// 清除"数字"以外的字符
			if (+row.increaseCount > 49) {
				row.increaseCount = 49
			}
			this.cusAll.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.increaseCount = row.increaseCount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.increaseCount = row.increaseCount
					}
				}
			})
			this.cusTable.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.increaseCount = row.increaseCount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.increaseCount = row.increaseCount
					}
				}
			})
			this.initCus()
		},
		rowIncreaseCountBlur (row) {
			if (row.increaseCount === '') {
				row.increaseCount = 0
			}
			this.cusAll.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.increaseCount = row.increaseCount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.increaseCount = row.increaseCount
					}
				}
			})
			this.cusTable.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.increaseCount = row.increaseCount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.increaseCount = row.increaseCount
					}
				}
			})
			this.initCus()
		},
		rowCouponamountCheck (row) {
			row.couponamount = row.couponamount.replace(/[^\d]/g, '')// 清除"数字"以外的字符
			if (+row.couponamount > 49) {
				row.couponamount = 49
			}
			this.cusAll.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.couponamount = row.couponamount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.couponamount = row.couponamount
					}
				}
			})
			this.cusTable.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.couponamount = row.couponamount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.couponamount = row.couponamount
					}
				}
			})
			this.initCus()
		},
		rowCouponamountBlur (row) {
			if (row.couponamount === '' || +row.couponamount < 1) {
				row.couponamount = 1
			}
			this.cusAll.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.couponamount = row.couponamount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.couponamount = row.couponamount
					}
				}
			})
			this.cusTable.forEach(item => {
				if (this.customertype === 0) {
					if (item.categoryid === row.categoryid) {
						item.couponamount = row.couponamount
					}
				} else {
					if (item.customerid === row.customerid) {
						item.couponamount = row.couponamount
					}
				}
			})
			this.initCus()
		},
		initCus () {
			let num = 0
			this.cusAll.forEach(item => {
				num = +num + +item.couponamount
			})
			this.couponamountAll = num
		},
		saveMutiClick () {
			if (this.mutiCouponamount === '') {
				let text = this.isAddEdit ? '请输入增发数量' : '请输入发券数量'
				this.$message.error(text)
				return false
			}
			this.cusAll.forEach(item => {
				if (this.isAddEdit) {
					item.increaseCount = this.mutiCouponamount
				} else {
					item.couponamount = this.mutiCouponamount
				}
			})
			this.cusTable = this.cusAll
			this.initCus()
			this.editNumModel = false
		},
		cancelMutiClick () {
			this.editNumModel = false
		},
		editNum (flag) {
			if (flag) {
				this.isAddEdit = true
			} else {
				this.isAddEdit = false
			}
			this.editNumModel = true
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					let id = window.sessionStorage.getItem('discountId')
					if (id) {
						this.isDisable = !this.AuthorityList['08_0003_0002_00']
					} else {
						this.isDisable = !this.AuthorityList['08_0003_0003_00']
					}
				}
			})
		},
		mutiCouponamountBlur () {
			if (this.mutiCouponamount === '' || +this.mutiCouponamount < 1) {
				this.mutiCouponamount = 1
			}
		},
		mutiCouponamountCheck () {
			this.mutiCouponamount = this.mutiCouponamount.replace(/[^\d]/g, '')// 清除"数字"以外的字符
			if (+this.mutiCouponamount > 49) {
				this.mutiCouponamount = 49
			}
		},
		increaseCountBlur () {
			if (this.increaseCount === '' || +this.increaseCount < 1) {
				this.increaseCount = 1
			}
		},
		couponamountBlur () {
			if (this.couponamount === '' || +this.couponamount < 1) {
				this.couponamount = 1
			}
		},
		increaseCountCheck () {
			this.increaseCount = this.increaseCount.replace(/[^\d]/g, '')// 清除"数字"以外的字符
			if (+this.increaseCount > 49) {
				this.increaseCount = 49
			}
		},
		couponamountCheck () {
			this.couponamount = this.couponamount.replace(/[^\d]/g, '')// 清除"数字"以外的字符
			if (+this.couponamount > 49) {
				this.couponamount = 49
			}
		},
		reliefmoneyBlur () {
			if (+this.reliefmoney > 100000) {
				this.reliefmoney = 99999.99
			}
		},
		reliefmoneyCheck () {
			this.reliefmoney = this.reliefmoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.reliefmoney = this.reliefmoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.reliefmoney = this.reliefmoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.reliefmoney = this.reliefmoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.reliefmoney = this.reliefmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		},
		useconditionmoneyBlur () {
			if (+this.useconditionmoney > 100000) {
				this.useconditionmoney = 99999.99
			}
		},
		useconditionmoneyCheck () {
			this.useconditionmoney = this.useconditionmoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.useconditionmoney = this.useconditionmoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.useconditionmoney = this.useconditionmoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			this.useconditionmoney = this.useconditionmoney.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
			this.useconditionmoney = this.useconditionmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
		},
		reloadCus (data) {
			this.chooseCus = data.chooseData
			this.customertype = data.customertype
			if (this.customertype === 0) {
				this.chooseCusByCate = this.chooseCus
			} else {
				this.chooseCusBylevel = this.chooseCus
			}
			this.cusKeyword = ''
			this.initCusData()
			this.customerDialog = false
		},
		initCusData () {
			let list = this.chooseCus
			let chooseList = []
			list.forEach(item => {
				if (this.customertype === 0) {
					let row = {
						categoryname: item.name,
						categoryid: item.id,
						couponamount: 1
					}
					chooseList.push(row)
				} else {
					item.cus.forEach(cusItem => {
						if (cusItem.checked === 1 && cusItem.id !== '-1') {
							let row = {
								categoryname: item.name,
								categoryid: item.id,
								customername: cusItem.name,
								customerid: cusItem.id,
								syscode: cusItem.syscode,
								couponamount: 1
							}
							chooseList.push(row)
						}
					})
				}
			})
			chooseList.forEach(item => {
				this.cusOld.forEach(old => {
					if (this.customertype === 0) {
						if (item.categoryid === old.categoryid) {
							item.couponamount = old.couponamount
						}
					} else {
						if (item.customerid === old.customerid) {
							item.couponamount = old.couponamount
						}
					}
				})
			})
			this.cusTable = chooseList
			this.cusAll = chooseList
			this.initCus()
		},
		initShopData (data) {
			let textArr = []
			let ids = []
			data.forEach(item => {
				ids.push(item.shopid)
				textArr.push(item.shopname)
			})
			this.shopText = textArr.join('，')
			this.chooseShop = ids
		},
		checkSave () {
			if (this.name === '') {
				this.$message.error('请填写活动名称')
				return false
			}
			if (this.useconditionflag === 1 && this.useconditionmoney === '') {
				this.$message.error('请输入使用门槛金额')
				return false
			}
			if (this.reliefmoney === '') {
				this.$message.error('请输入优惠内容')
				return false
			}
			if (this.useconditionflag === 1 && +this.reliefmoney > +this.useconditionmoney) {
				this.$message.error('减免金额须小于等于满额金额')
				return false
			}
			if (this.discountDateType === 1 && (this.dateValue === null || this.dateValue.length === 0)) {
				this.$message.error('请选择使用时间')
				return false
			}
			if (this.coupondatetype === 0 && (this.coupondate === '' || this.coupondate === null)) {
				this.$message.error('请选择上架/发放时间')
				return false
			}
			if (this.shopattendway === 1 && this.chooseShop.length === 0) {
				this.$message.error('请选择适用店铺')
				return false
			}
			if (this.attendway === 1 && this.cusAll.length === 0) {
				this.$message.error('请选择适用客户')
				return false
			}
			if (this.couponamount === '' && this.attendway === 0) {
				this.$message.error('请输入每个客户发券数量')
				return false
			}
			if ((this.productattendway === 1 && this.proAll.length === 0) || (this.productattendway === 2 && this.checkList.length === 0)) {
				this.$message.error('请选择适用商品')
				return false
			}
			return true
		},
		editSave () {
			let params = {
				id: this.discountId,
				name: this.name,
				memo: this.memo
			}
			let message = ''
			if (this.orginName !== this.name) {
				message = `商品券名称由${this.orginName}改为${this.name}`
			} else {
				message = '商品券名称为' + this.name
			}
			if (this.attendway === 0) {
				params.increaseCount = this.increaseCount
				message = message + '每个客户增发数量：' + this.increaseCount
			} else {
				let list = []
				let msgList = []
				this.cusAll.forEach(item => {
					let row = {
						rdcId: item.id,
						increaseCount: item.increaseCount
					}
					list.push(row)
					let rowMsg = ''
					if (this.customertype === 1) {
						rowMsg = rowMsg + item.customername + '增发数量：' + item.increaseCount
					} else {
						rowMsg = rowMsg + item.categoryname + '增发数量：' + item.increaseCount
					}
					msgList.push(rowMsg)
				})
				params.customerDetail = list
				message = message + msgList.join(',')
			}
			let loggerMessage = message
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			params.logMessage = {
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/editDiscountCoupon`,
				data: params
			}).then(res => {
				if (res.result) {
					this.discountId = res.data
					window.sessionStorage.setItem('discountId', res.data)
					this.isAdd = false
					this.cusKeyword = ''
					this.proKeyword = ''
					this.increaseCount = 0
					this.getDetail()
					this.getAuthority('08_0003_0000_00')
					this.$message.success('保存成功!')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		saveClick () {
			if (!this.checkSave()) {
				return false
			}
			if (this.discountState) {
				this.editSave()
				return false
			}
			let params = {
				type: this.type,
				id: this.discountId,
				name: this.name,
				discountDateType: this.discountDateType,
				attendway: this.attendway,
				beginDate: this.dateValue[0],
				endDate: this.dateValue[1],
				memo: this.memo,
				useconditionflag: this.useconditionflag,
				useconditionmoney: this.useconditionmoney,
				reliefmoney: this.reliefmoney,
				addupflag: this.addupflag,
				coupondatetype: this.coupondatetype,
				coupondate: this.coupondate,
				shopattendway: this.shopattendway,
				productattendway: this.productattendway,
				categoryOrLevelFlag: this.customertype === 0 ? 1 : 0,
				customerDetail: this.cusAll,
				shopIds: this.chooseShop,
				couponamount: this.couponamount
			}
			if (this.productattendway === 1) {
				params.detail = this.proAll
			} else if (this.productattendway === 2) {
				let arr = []
				this.checkList.forEach(item => {
					let row = {
						categoryid: item
					}
					arr.push(row)
				})
				params.detail = arr
			}
			let message = ''


			let id = window.sessionStorage.getItem('discountId')
			if (id) {
				message = '修改为：' + this.createLoggerParams()
			} else {
				message = '新建：' + this.createLoggerParams()
			}
			let loggerMessage = message
			let loggerUrl = window.location.href.split('?')[0]
			loggerUrl = loggerUrl.replace(window.location.origin, '').substring(1)
			params.logMessage = {
				message: loggerMessage,
				referer: loggerUrl
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/saveorupdate4coupon`,
				data: params
			}).then(res => {
				if (res.result) {
					this.discountId = res.data
					window.sessionStorage.setItem('discountId', res.data)
					this.isAdd = false
					this.cusKeyword = ''
					this.proKeyword = ''
					this.getDetail()
					this.getAuthority('08_0003_0000_00')
					this.$message.success('保存成功!')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		addCusClick () {
			this.cusOld = this.cusAll
			this.customerDialog = true
		},
		getDetail () {
			let params = {
				id: this.discountId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/discount/getdetail4coupon`,
				data: params
			}).then(res => {
				if (res.result) {
					this.type = res.data.discount.type
					this.discountState = res.data.discountState === 1
					this.name = res.data.discount.name
					this.orginName = res.data.discount.name
					this.shopattendway = res.data.discount.shopattendway
					this.attendway = res.data.discount.attendway
					this.discountDateType = res.data.discount.discountDateType
					this.memo = res.data.discount.memo
					if (res.data.discount.discountDateType === 1) {
						this.dateValue = [res.data.discount.begindate, res.data.discount.enddate]
					} else {
						this.dateValue = []
					}
					this.couponamount = res.data.coupon.couponamount
					this.productattendway = res.data.coupon.productattendway
					this.useconditionflag = res.data.coupon.useconditionflag
					this.useconditionmoney = res.data.coupon.useconditionmoney
					this.reliefmoney = res.data.coupon.reliefmoney
					this.addupflag = res.data.coupon.addupflag
					this.coupondatetype = res.data.coupon.coupondatetype
					this.coupondate = res.data.coupon.coupondate
					this.forceflag = res.data.coupon.forceflag
					this.customertype = res.data.coupon.customercategoryflag === 1 ? 0 : 1
					if (this.productattendway === 1) {
						this.proAll = res.data.productList
						this.proTable = res.data.productList
					} else if (this.productattendway === 2) {
						this.proTable = []
						this.proAll = []
						let list = []
						res.data.productList.forEach(item => {
							list.push(item.categoryid)
						})
						this.checkList = list
					}
					let cusList = []
					res.data.customerList.forEach(item => {
						item.increaseCount = 0
						cusList.push(item)
					})
					cusList = JSON.parse(JSON.stringify(cusList))
					this.cusAll = cusList
					this.cusTable = cusList
					this.initChooseCus(this.cusAll, this.customertype)
					this.initShopData(res.data.shops)
					this.saveData(res.data)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			let cusTextArr = []
			let proTextArr = []
			let cusList = this.cusAll
			cusList.forEach(item => {
				if (item.customername) {
					cusTextArr.push('【' + item.syscode + '（' + item.customername + '）】发券数量' + item.couponamount)
				} else {
					cusTextArr.push(item.categoryname + '发券数量' + item.couponamount)
				}
			})
			if (this.productattendway === 1) {
				let proList = this.proAll
				proList.forEach(item => {
					let text = ''
					text = item.productname
					proTextArr.push(text)
				})
			}
			if (this.productattendway === 2) {
				this.checkList.forEach(item => {
					this.categoryList.forEach(cateItem => {
						if (item === cateItem.id) {
							proTextArr.push(cateItem.name)
						}
					})
				})
			}

			let protext = ''
			if (this.productattendway === 0) {
				protext = '全部商品'
			}
			if (this.productattendway === 1) {
				protext = '指定商品' + proTextArr.join(',')
			}
			if (this.productattendway === 2) {
				protext = '指定分类' + proTextArr.join(',')
			}
			let params = {
				name: this.name,
				useconditionflag: this.useconditionflag === 0 ? '无门槛使用' : '订单满' + this.useconditionmoney,
				reliefmoney: this.reliefmoney,
				discountDateType: this.discountDateType === 1 ? '有效期' + this.dateValue[0] + '-' + this.dateValue[1] : '永久',
				addupflag: this.addupflag === 0 ? '不可与其它活动叠加使用' : '可与其它活动叠加使用',
				memo: this.memo,
				coupondatetype: this.coupondatetype === 0 ? '规定时间' + this.coupondate : '立即上架/发放',
				shop: this.shopattendway === 0 ? '全部店铺' : '部分店铺' + this.shopText,
				cus: this.attendway === 0 ? '全部客户发券数量' + this.couponamount : '部分客户' + cusTextArr.join('，'),
				pro: protext
			}
			let msg = ''
			msg = (this.type === 1 ? '满减券' : '商品券') + `名称：${params.name}，使用门槛：${params.useconditionflag}，优惠内容：${params.reliefmoney}，使用时间：${params.discountDateType}，优惠叠加:${params.addupflag}，发放时间：${params.coupondatetype}；适用店铺:${params.shop}，适用客户:${params.cus}，适用商品：${params.pro}`
			return msg
		},
		saveData (data) {
			let shopTextArr = []
			let cusTextArr = []
			let proTextArr = []
			let shopList = data.shops
			shopList.forEach(item => {
				shopTextArr.push(item.shopname)
			})
			let cusList = data.customerList
			cusList.forEach(item => {
				if (item.customername) {
					cusTextArr.push('【' + item.syscode + '（' + item.customername + '）】【' + item.couponamount + '】')
				} else {
					cusTextArr.push(item.categoryname + '【' + item.couponamount + '】')
				}
			})
			let proList = data.productList
			if (data.coupon.productattendway === 1) {
				proList.forEach(item => {
					let text = ''
					text = item.productname
					proTextArr.push(text)
				})
			}
			if (this.productattendway === 2) {
				proList.forEach(item => {
					this.categoryList.forEach(cateItem => {
						if (item.categoryid === cateItem.id) {
							proTextArr.push(cateItem.name)
						}
					})
				})
			}
			let protext = ''
			if (data.coupon.productattendway === 0) {
				protext = '全部商品'
			}
			if (data.coupon.productattendway === 1) {
				protext = '指定商品' + proTextArr.join(',')
			}
			if (data.coupon.productattendway === 2) {
				protext = '指定分类' + proTextArr.join(',')
			}
			let params = {
				name: data.discount.name,
				useconditionflag: data.coupon.useconditionflag === 0 ? '无门槛使用' : '订单满' + data.coupon.useconditionmoney,
				reliefmoney: data.coupon.reliefmoney,
				discountDateType: data.discount.discountDateType === 1 ? '有效期' + data.discount.begindate + '-' + data.discount.enddate : '永久',
				addupflag: data.coupon.addupflag === 0 ? '不可与其它活动叠加使用' : '可与其它活动叠加使用',
				memo: data.discount.memo,
				coupondatetype: data.coupon.coupondatetype === 0 ? '规定时间' + data.coupon.coupondate : '立即上架/发放',
				shop: data.discount.shopattendway === 0 ? '全部店铺' : '部分店铺' + shopTextArr.join('，'),
				cus: data.discount.attendway === 0 ? '全部客户【' + data.coupon.couponamount + '】' : '部分客户' + cusTextArr.join('，'),
				pro: protext
			}
			this.fxDataVerification.resetData(params)
		},
		initChooseCus (list, type) {
			if (type === 0) {
				let arr = []
				list.forEach(item => {
					let row = {
						categoryOrLevelFlag: 1,
						id: item.categoryid,
						name: item.categoryname,
						cus: []
					}
					arr.push(row)
				})
				this.chooseCusByCate = arr
				this.chooseCusBylevel = []
			} else {
				let chooseArr = []
				let arr = []
				list.forEach(item => {
					if (chooseArr.indexOf(item.categoryid) === -1) {
						let row = {
							categoryOrLevelFlag: 0,
							id: item.categoryid,
							name: item.categoryname,
							cus: []
						}
						chooseArr.push(item.categoryid)
						arr.push(row)
					}
				})
				list.forEach(item => {
					arr.forEach(arrItem => {
						if (item.categoryid === arrItem.categoryid) {
							let row = {
								id: item.customerid,
								name: item.customername
							}
							arr.cus.push(row)
						}
					})
				})
				this.chooseCusByCate = []
				this.chooseCusBylevel = arr
			}
			this.initCus()
		},
		delCusClick (row) {
			let index = null
			let id = null
			let key = ''
			if (this.customertype === 1) {
				id = row.customerid
				key = 'customerid'
			} else {
				id = row.categoryid
				key = 'categoryid'
			}
			this.cusAll.forEach((item, i) => {
				if (item[key] === id) {
					index = i
				}
			})
			this.cusAll.splice(index, 1)
			this.cusSearch()
		},
		delClick (id) {
			let index = null
			this.proAll.forEach((item, i) => {
				if (item.productid === id) {
					index = i
				}
			})
			this.proAll.splice(index, 1)
			this.proSearch()
		},
		cancelClick () {
			this.productModel = false
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.productTableData, data)
		},
		addproductClick () {
			if (this.chooseProduct === null) {
				this.$message.error('最少选择一个商品')
				return false
			}
			this.proKeyword = ''
			this.proAll = this.proAll.concat(this.chooseProduct)
			this.proTable = this.proAll
			this.productModel = false
		},
		getCategoryList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/baseCategory/getShopCategories4Gift`
			}).then(res => {
				this.categoryList = res.data
			})
		},
		clearSearch () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.typeCategory = '0'
			this.productDisabledflag = -1
			this.productKeyword = ''
			this.tableSelectUtils.clear()
			this.search()
		},
		searchClick () {
			this.tableSelectUtils.clear()
			this.search()
		},
		productSizeChange (val) {
			this.productPagination.size = val
			this.search()
		},
		productPageChange (val) {
			this.productPagination.page = val
			this.search()
		},
		search () {
			let ids = this.proAll.map(item => {
				return item.productid
			})
			let params = {
				productIds: ids,
				typeCategory: this.typeCategory,
				disabledflag: this.productDisabledflag,
				keyword: this.productKeyword,
				page: this.productPagination.page,
				size: this.productPagination.size
			}
			let url = `${this.$fxBaseApi.urlIV}/shop/discount/productlist4coupon`
			this.$store.dispatch('requestPost', {
				url: url,
				data: params
			}).then(res => {
				this.productTableData = res.recordList
				if (this.productTableData !== null) {
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.productTableData, this.$refs.table)
					})
				}
				this.productTotalCount = res.recordCount
			})
		},
		goBack () {
			this.$fxEventBus.$emit('setMenu', '9-3')
			this.$router.push('discountList')
		},
		addProduct () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.productTableData = []
			this.typeCategory = '0'
			this.productDisabledflag = -1
			this.productKeyword = ''
			this.tableSelectUtils.clear()
			this.productModel = true
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		}
	}
}
</script>
<style lang="stylus" scoped>
.li-top {
  width: 350px;
  height: 87px;
  position: relative;
  display: flex;
}
.li-top .head-img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.li-left {
  width: 210px;
  font-size: 10px;
  padding: 10px;
  padding-left: 15px;
  z-index: 10;
  box-sizing: border-box;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
}
.left-title {
  font-size: 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
}
.li-left .left-cion {
  display: inline-block;
  width: 40px;
  height: 17px;
  text-align: center;
  line-height: 17px;
  background: #E86C57;
  border-radius: 15px;
  font-size: 10px;
  color: #fff;
  font-weight: normal;
  margin-right: 8px;
}
.li-left .arrow-icon {
  width: 8px;
  height: 8px;
  margin-left: 5px;
}
.left-shop {
  color: #666;
  display: flex;
  align-items: center;
}
.li-right {
  width: 140px;
  font-size:12px;
  padding: 7px;
  box-sizing: border-box;
  flex-direction: column;
  display: flex;
  justify-content: space-around;
  position: relative;
  color: #fff;
  align-items: center;
}
.li-right .right-num {
  position: absolute;
  top: 5px;
  right: 3px;
  font-weight: bold;
  color: #333;
  font-size: 10px;
}
.li-right .right-use {
  width: 65px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  background: #FCE4B9;
  border-radius: 15px;
  font-size: 11px;
  color: #BF4B47;
  font-weight: bold;
}
.li-des {
  width: 350px;
  background-color:#FFF0D7;
  padding: 12px 10px;
  box-sizing: border-box;
  color: #595959;
  font-size: 10px;
}
.gift-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow :hidden;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.order-menu {
		height: 50px
		line-height: 50px
		text-align: left
		font-size: 15px
		border-bottom: 1px solid #dce1fe
		box-sizing: border-box
		span {
			display: inline-block;
			line-height: 50px;
			padding-right: 10px;
			i {
				border-radius: 50%;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
	}
	.gift-row{
		min-height :40px;
		display :flex;
		flex-direction :row;
		align-items :center;
		.gift-row-title{
			width :130px;
			height :40px;
			display :flex;
			align-items :center;
			font-size :13px;
			justify-content: flex-end;
		}
		.gift-row-content{
			height:40px;
			display :flex;
			align-items :center;
			text-align :left
		}
		.condition-des {
			color:#EE4F31;
			text-align:left;
			margin-bottom: 5px
		}
	}
	.main-product-box{
		text-align: left;
	}
	.product-name-box{
		display:inline-block;
		background-color:#eceffc;
		padding:0px 10px;
		line-height:30px;
		margin-left:10px;
		border-radius: 4px;
	}
	.filters-container {
		display: flex;
		flex-direction: row;
		height: 50px;
		align-items: center;
		margin-bottom:10px;
		.input-box{
			margin-right:10px
		}
		.el-input {
			width: 200px
		}
	}
	.point{
		width:6px;
		height:6px;
		border-radius:50%;
		margin-right:10px;
	}
	.point-box{
		display :flex;
		align-items:center;
		justify-content :center
	}
	.valet-foot{
		height :40px;
		display :flex;
		align-items center;
		justify-content :center
	}
}

</style>
<style lang="stylus">
.gift-body {
	.radioClass {
		.el-radio__label{
			display:none
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}
	.cell{
		padding :0px !important
	}
}
.el-picker-panel__footer{
		.el-picker-panel__link-btn.el-button--text  {
			display: none;
		}
	}
</style>
